import { format, parseISO } from "date-fns";

export const DATE_ONLY_FORMAT = "yyyy-MM-dd";

const toDate = (date: string | Date): Date =>
  typeof date === "string" ? parseISO(date) : date;

export const parseDateOnly = (dateInput: string | Date): Date => {
  if (dateInput instanceof Date) {
    return new Date(format(dateInput, DATE_ONLY_FORMAT) + "T00:00:00");
  }
  const dateOnly = dateInput.split("T")[0];
  return new Date(dateOnly + "T00:00:00");
};

export const formatDateShort = (date: string | Date): string =>
  format(toDate(date), "MMM d, yyyy");

export const formatDateTime = (date: string | Date): string =>
  format(toDate(date), "MMM d, yyyy 'at' h:mm a");

export const formatMonthYear = (date: string | Date): string =>
  format(toDate(date), "MMM yyyy");

export const formatDateSlash = (date: string | Date): string =>
  format(toDate(date), "MM/dd/yyyy");

export const formatMonthSlashYear = (date: string | Date): string =>
  format(toDate(date), "M/yyyy");

export const formatDateLong = (date: string | Date): string =>
  format(toDate(date), "MMMM d, yyyy");
